import { storageFactory } from '@hotjar/insights-common/lib/storage-factory';
import { CHECKOUT } from '../constants/routes';
import type { BillingPeriod, ProductAllowance } from '../api/common/model/subscription';
import { navigateTo } from '../external-dependencies/webapp-utils';
import type {
  DraftOrderData,
  DraftOrderType,
  UpdateDraftOrderData,
  UpdateDraftOrderOptions,
} from './types';

const storage = storageFactory('sessionStorage');

const DRAFT_ORDER_PROPERTIES: DraftOrderType[] = ['billingPeriod', 'products'];

export async function updateDraftOrder<TType extends DraftOrderType>(
  data: UpdateDraftOrderData<TType>,
  options?: UpdateDraftOrderOptions,
): Promise<void> {
  const { type, payload } = data;

  storage.set(type, payload);

  if (options?.checkoutOnSuccess === true) {
    navigateTo(CHECKOUT);
  }
}

export async function clearDraftOrder(): Promise<void> {
  DRAFT_ORDER_PROPERTIES.forEach((property) => {
    storage.remove(property);
  });
}

export async function getDraftOrder(): Promise<DraftOrderData> {
  const products = storage.get<ProductAllowance[]>('products');
  const billingPeriod = storage.get<BillingPeriod>('billingPeriod');

  return {
    products,
    billingPeriod,
  };
}
